export default function Help() {
    return (
        <svg id="Group_566" data-name="Group 566" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path id="Path_211" data-name="Path 211" d="M0,0H24V24H0Z" fill="none"/>
            <path id="Path_212" data-name="Path 212" d="M12,22A10,10,0,1,1,22,12,10,10,0,0,1,12,22Zm0-2a8,8,0,1,0-8-8A8,8,0,0,0,12,20Zm-1-5h2v2H11Zm2-1.645V14H11V12.5a1,1,0,0,1,1-1,1.5,1.5,0,1,0-1.471-1.794L8.567,9.313A3.5,3.5,0,1,1,13,13.355Z" fill="#cecece"/>
        </svg>
    )
}